import _ from 'lodash';
import React, { useState, useRef } from 'react';

export default function FreeZoneVideoBlock({ data, id }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const videoRef = useRef(null);

  const handleTogglePlayback = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
    setIsPlaying((prev) => !prev);
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };

  return (
    <section id={id}>
      {_.isEmpty(data.videoUrl) || (
        <div
          className="w-full md:h-[600px] z-10 relative"
          onMouseLeave={handleMouseLeave}
          onMouseEnter={handleMouseEnter}>
          {data.videoUrl.toLowerCase().includes('.mp4') ? (
            <>
              <video 
              className="w-full pointer-events-none h-full aspect-[320/200] 
              sm:aspect-video object-cover" 
                ref={videoRef}
                muted
                playsInline
                loop
                autoPlay
                >
                <source src={data.videoUrl} type="video/mp4" />
              </video>
              {/* <button
                type="button"
                onClick={handleTogglePlayback}
                className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-0 bg-white z-20 
                  w-[50px] h-[50px] md:w-[75px] md:h-[75px] 2l:w-[100px] 2l:h-[100px] rounded-full transition-opacity duration-300
                  ${isPlaying ? (isMouseOver ? 'opacity-100' : 'opacity-0') : ''} `}>
                {isPlaying ? (
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="50" fill="#CE445B" />
                    <path
                      d="M58.8229 34.0001H51.7658C51.5038 34.0001 51.2915 34.2124 51.2915 34.4744V65.5258C51.2915 65.7877 51.5038 66 51.7658 66H58.8229C59.0849 66 59.2971 65.7877 59.2971 65.5258V34.4744C59.2971 34.2124 59.0849 34.0001 58.8229 34.0001Z"
                      fill="white"
                    />
                    <path
                      d="M47.5314 34H40.4742C40.2123 34 40 34.2123 40 34.4742V65.5256C40 65.7876 40.2123 65.9999 40.4742 65.9999H47.5314C47.7933 65.9999 48.0056 65.7876 48.0056 65.5256V34.4742C48.0056 34.2123 47.7933 34 47.5314 34Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="50" fill="#CE445B" />
                    <path
                      d="M39.8571 65C39.7093 65 39.5614 64.9619 39.4286 64.8851C39.1633 64.7321 39 64.4489 39 64.1429L39.0009 35.857C39.0009 35.551 39.1641 35.2678 39.4294 35.1148C39.6947 34.9617 40.0213 34.9617 40.2866 35.1148L64.783 49.2577C65.0482 49.4107 65.2115 49.6939 65.2115 49.9999C65.2115 50.3059 65.0482 50.5892 64.783 50.7422L40.2857 64.8851C40.1529 64.9619 40.005 65 39.8571 65Z"
                      fill="white"
                    />
                  </svg>
                )}
              </button> */}
            </>
          ) : (
            <iframe
              src={data.videoUrl}
              title="Free Zone Video Block"
              className="max-h-[600px] h-auto aspect-video w-full"
            />
          )}
        </div>
      )}
    </section>
  );
}
